var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"container"}},[_c('h1',{staticClass:"u-link-white",attrs:{"href":"#"}},[_vm._v(_vm._s(_vm.timeFormatted))]),_c('h2',[_vm._v("Before the exam shall start.")])])}
var staticRenderFns = []

export { render, staticRenderFns }